/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { SubcontractorChangeOrderRequestsControllerCreateMutationRequest, SubcontractorChangeOrderRequestsControllerCreateMutationResponse, SubcontractorChangeOrderRequestsControllerCreatePathParams, SubcontractorChangeOrderRequestsControllerCreate400, SubcontractorChangeOrderRequestsControllerCreate401, SubcontractorChangeOrderRequestsControllerCreate403 } from "../../models/changeOrdersController/SubcontractorChangeOrderRequestsControllerCreate";

function getSubcontractorChangeOrderRequestsControllerCreateUrl(id: SubcontractorChangeOrderRequestsControllerCreatePathParams["id"]) {
  const res = { method: 'POST', url: `/api/v1/potential-change-orders/${id}/subcontractor-change-order-requests` as const }  
  return res
}

/**
 * @summary Attach an ordinary project file to a potential change order
 * {@link /api/v1/potential-change-orders/:id/subcontractor-change-order-requests}
 */
export async function subcontractorChangeOrderRequestsControllerCreate(id: SubcontractorChangeOrderRequestsControllerCreatePathParams["id"], data?: SubcontractorChangeOrderRequestsControllerCreateMutationRequest, config: Partial<RequestConfig<SubcontractorChangeOrderRequestsControllerCreateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<SubcontractorChangeOrderRequestsControllerCreateMutationResponse, ResponseErrorConfig<SubcontractorChangeOrderRequestsControllerCreate400 | SubcontractorChangeOrderRequestsControllerCreate401 | SubcontractorChangeOrderRequestsControllerCreate403>, SubcontractorChangeOrderRequestsControllerCreateMutationRequest>({ method : "POST", url : getSubcontractorChangeOrderRequestsControllerCreateUrl(id).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}